import { Modal, Spin } from 'lego-on-react';
import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/SkillCreation';
import block from 'propmods';

import { Channel } from '../../model/skill';

import './SkillCreationPopup.scss';

const t = i18n(keyset);

interface SkillCreationPopupProps {
    visible?: boolean;
    progress?: boolean;
    onSelect: (channel: Channel) => void;
    onClose: () => void;
    userAgreementLink: string;
}

const b = block('SkillCreationPopup');

export default function SkillCreationPopup(props: SkillCreationPopupProps) {
    return (
        <Modal autoclosable visible={props.visible} onOutsideClick={props.onClose} directions={['bottom-left']}>
            <div {...b()}>
                <div {...b('header')}>{t('choose-type')}</div>

                <div {...b('main')}>
                    <div {...b('button')} onClick={() => props.onSelect(Channel.AliceSkill)}>
                        <div {...b('icon', { channel: Channel.AliceSkill })} />
                        <div {...b('title')}>{t('alice-skill')}</div>
                        <div {...b('description')}>{t('teach-alice')}</div>
                    </div>

                    <div {...b('button')} onClick={() => props.onSelect(Channel.SmartHome)}>
                        <div {...b('icon', { channel: Channel.SmartHome })} />
                        <div {...b('title')}>{t('smart-home')}</div>
                        <div {...b('description')}>{t('teach-smart-home')}</div>
                    </div>
                </div>

                <div {...b('footer')}>
                    {t('user-agreement__1')}{' '}
                    <a href={props.userAgreementLink} rel="noreferrer noopener" target="_blank">
                        {t('user-agreement__2')}
                    </a>
                    .
                </div>

                {props.progress && (
                    <div {...b('progress')}>
                        <Spin size="l" progress />
                    </div>
                )}
            </div>
        </Modal>
    );
}
